import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef, SopoDialogSettings } from '../../interfaces/dialog';

export class SopoVerifyAdditionalDataSettings extends SopoDialogSettings {
    data: SopoVerifyAdditionalDataInput;
}

export interface SopoVerifyAdditionalDataInput {
    header?: string;
    body?: string;
    birthDateNeeded?: boolean;
    ssn4Needed?: boolean;
    firstNameNeeded?: boolean;
    birthDate?: string;
    ssn4?: string;
    firstName?: string;
    alreadyTried?: boolean;
    showManualSignup?: boolean;
}

@Component({
    selector: 'app-verify-info',
    templateUrl: './sopo-verify-additional-info.component.html',
    styleUrls: ['./sopo-verify-additional-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SopoVerifyAdditionalInfoComponent implements OnInit {
    header = 'Verify Your Information';
    body = '';
    birthDateNeeded = false;
    ssn4Needed = false;
    firstNameNeeded = false;
    ageError = false;
    missingFieldsError = false;
    alreadyTried = false;
    showManualSignup = false;

    form: SopoVerifyAdditionalDataInput;

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoVerifyAdditionalDataInput,
        private dialogRef: SopoDialogRef,
        private ref: ChangeDetectorRef
    ) {
        this.form = {
            ssn4: '',
            birthDate: new Date().toISOString(),
            firstName: '',
        };
        this.birthDateNeeded = data.birthDateNeeded ? data.birthDateNeeded : false;
        this.ssn4Needed = data.ssn4Needed ? data.ssn4Needed : false;
        this.firstNameNeeded = data.firstNameNeeded ? data.firstNameNeeded : false;
        this.alreadyTried = data.alreadyTried ? data.alreadyTried : false;
        if (data.showManualSignup) this.showManualSignup = true;

        if (this.birthDateNeeded && this.ssn4Needed && this.firstNameNeeded) {
            this.body = 'Enter your real first name, birthday and SSN so we can verify you.';
        } else if (this.birthDateNeeded && this.ssn4Needed) {
            this.body = 'Enter your real birthday and SSN so we can verify you.';
        } else if (this.birthDateNeeded && this.firstNameNeeded) {
            this.body = 'Enter your real first name and birthday so we can verify you.';
        } else if (this.ssn4Needed && this.firstNameNeeded) {
            this.body = 'Enter your real first name and SSN so we can verify you.';
        } else if (this.birthDateNeeded) {
            this.body = 'Enter your real birthday so we can verify you and autofill your info.';
        } else if (this.ssn4Needed) {
            this.body = 'Enter your SSN for verification.';
        } else if (this.firstNameNeeded) {
            this.body = 'Enter your first name for verification.';
        }
    }

    ngOnInit(): void {}

    async confirm() {
        this.ageError = false;
        this.missingFieldsError = false;

        if (this.birthDateNeeded && !this.isAboveLegalAge()) {
            this.ageError = true;
            this.ref.detectChanges();
        }

        if (this.formHasMissingFields()) {
            this.missingFieldsError = true;
            this.ref.detectChanges();
        }

        if (!this.ageError && !this.missingFieldsError) {
            this.dialogRef.close(this.form);
        }
    }

    isAboveLegalAge() {
        if (!this.form.birthDate) return false;

        const birthDate = new Date(this.form.birthDate);
        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        return age > 18 || (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)));
    }

    formHasMissingFields(): boolean {
        if (this.birthDateNeeded && !this.form.birthDate) return true;
        if (this.ssn4Needed && !this.form.ssn4) return true;
        if (this.firstNameNeeded && !this.form.firstName) return true;
        return false;
    }

    cancel() {
        this.dialogRef.close(null);
    }

    manualSignup() {
        this.dialogRef.close({ manualSignup: true });
    }
}
